<template>
	<div v-show="isInit">
		<div class="contract_container">
			<div class="container">
				<div id="zoomBox">
					<div class="contract_main">
						<div class="tips">*请在合同结尾处签字</div>
						<div class="contract_title">
							<span>{{ contractTypeStr }}</span>
							<span class="contractno">{{ navigatorTitle }}</span>
						</div>
						<table border="0" cellpadding="0" cellspacing="0" class="mytable">
							<tr v-if="customerInfo && userInfo">
								<td width="12%">
									<div class="b_in">
										<span>买</span><span>方</span><span>名</span><span>称</span>
									</div>
								</td>
								<td width="38%">{{ customerInfo.departName }}</td>
								<td width="12%">
									<div class="b_in">
										<span>卖</span><span>方</span><span>名</span><span>称</span>
									</div>
								</td>
								<td width="38%" class="noborder">{{ userInfo.departName }}</td>
							</tr>
							<tr v-if="customerInfo && userInfo">
								<td>
									<div class="b_in">
										<span>地</span><span>址</span>
									</div>
								</td>
								<td>{{ customerInfo.address }}</td>
								<td>
									<div class="b_in">
										<span>地</span><span>址</span>
									</div>
								</td>
								<td class="noborder">{{ userInfo.address }}</td>
							</tr>
							<tr v-if="customerInfo && userInfo">
								<td>
									<div class="b_in">
										<span>联</span><span>系</span><span>人</span>
									</div>
								</td>
								<td>{{ customerInfo.customerName }}</td>
								<td>
									<div class="b_in">
										<span>联</span><span>系</span><span>人</span>
									</div>
								</td>
								<td class="noborder">{{ userInfo.realname }}</td>
							</tr>
							<tr v-if="customerInfo && userInfo">
								<td>
									<div class="b_in">
										<span>电</span><span>话</span>
									</div>
								</td>
								<td>{{ customerInfo.phone }}</td>
								<td>
									<div class="b_in">
										<span>电</span><span>话</span>
									</div>
								</td>
								<td class="noborder">{{ userInfo.phone }}</td>
							</tr>
							<tr v-if="customerInfo && userInfo">
								<td>
									<div class="b_in">
										<span>开</span><span>户</span><span>行</span>
									</div>
								</td>
								<td>{{ customerInfo.openingBank }}</td>
								<td>
									<div class="b_in">
										<span>开</span><span>户</span><span>行</span>
									</div>
								</td>
								<td class="noborder">{{ userInfo.openingBank }}</td>
							</tr>
							<tr v-if="customerInfo && userInfo">
								<td>
									<div class="b_in">
										<span>账</span><span>号</span>
									</div>
								</td>
								<td>{{ customerInfo.bankNumber }}</td>
								<td>
									<div class="b_in">
										<span>账</span><span>号</span>
									</div>
								</td>
								<td class="noborder">{{ userInfo.bankNumber }}</td>
							</tr>
							<tr v-if="customerInfo && userInfo">
								<td>
									<div class="b_in">
										<span>税</span><span>号</span>
									</div>
								</td>
								<td>{{ customerInfo.dutyParagraph }}</td>
								<td>
									<div class="b_in">
										<span>税</span><span>号</span>
									</div>
								</td>
								<td class="noborder">{{ userInfo.dutyParagraph }}</td>
							</tr>
							<tr>
								<td colspan="4" class="top_line">
									买、卖双方根据《中华人民共和国合同法》及《经济法》相关法律规定，经友好协商，签订本合同。
								</td>
							</tr>
						</table>

						<!-- <div class="project_info" v-if="orderAddressInfo">
							<div class="project_main">
								<div>
									项目名称：{{ orderAddressInfo.projectName }}<br />
									送货地址：{{ orderAddressInfo.provinceName }}{{ orderAddressInfo.cityName }}{{ orderAddressInfo.districtName
									}}
									{{ orderAddressInfo.address }}
								</div>
								<div>
									收货人：{{ orderAddressInfo.uaRealName }}<br />
									联系电话：{{ orderAddressInfo.uaMobile }}
								</div>
							</div>
						</div> -->
						<div class="product_info">
							<table border="0" cellpadding="0" cellspacing="0" class="mytable1">
								<tr>
									<td>项</td>
									<td v-for="(sub, subIndex) in tableTitles" :key="subIndex" class="table_bg">{{ sub.label }}</td>
								</tr>
								<tr v-for="(item, index) in productList" :key="index">
									<td>{{ index + 1 }}</td>
									<td v-if="printFields.indexOf('productName') >= 0">{{ item.productName }}</td>
									<!-- 规格型号 -->
									<!-- 自定义商品   成品件-->
									<template v-if="(item.proType == 3 || item.proType == 1) && printFields.indexOf('standardsName') >= 0">
										<td>{{ item.standardsName }}</td>
									</template>
									<!-- 加工件 -->
									<template v-if="(item.proType == 2 || item.proType == 4) && printFields.indexOf('standardsName') >= 0">
										<td>{{ handerNodeValueList(item.nodeValueList) }}</td>
									</template>
									<!-- 单位 -->
									<td v-if="printFields.indexOf('unitName') >= 0">{{ item.unitName }}</td>
									<!-- 数量 -->
									<td v-if="printFields.indexOf('orderNum') >= 0">{{ item.orderNum }}</td>
									<!-- 参数 -->
									<td v-if="printFields.indexOf('ps') >= 0">{{ item.ps }}</td>
									<!-- 面积 -->
									<td v-if="printFields.indexOf('areaNumContract') >= 0">{{ item.areaNumContract }}</td>
									<!-- 合计面积 -->
									<td v-if="printFields.indexOf('totalAreaNumContract') >= 0">{{ (item.orderNum *
										item.areaNumContract).toFixed(4) }}</td>
									<!-- 平方单价 -->
									<td v-if="printFields.indexOf('areaUnitPrice') >= 0">{{ item.outFactoryBasePrice }}</td>
									<!-- 出厂价 -->
									<!-- {{ item.outFactoryPrice }} -->
									<td v-if="printFields.indexOf('outFactoryPrice') >= 0">~</td>
									<!-- 单件价￥ -->
									<td v-if="printFields.indexOf('outFactoryBasePrice') >= 0">{{ item.areaUnitPrice }}</td>
									<!-- 小计 -->
									<td v-if="printFields.indexOf('totalAmountContract') >= 0">{{ item.totalAmountContract }}</td>
								</tr>
								<tr class="table_foot"
									v-if="isShowOrderNum || isShowOutFactoryPrice || isShowUnitPrice || isShowTotalAmount">
									<td>合计</td>
									<td v-for="(item, index) in tableTitles" :key="index">
										<span v-if="item.key == 'orderNum'">{{ totalCount }}</span>
										<span v-if="item.key == 'outFactoryPrice'"></span>
										<span v-if="item.key == 'outFactoryBasePrice'"></span>
										<span v-if="item.key == 'totalAmountContract'">{{ totalPrice.toFixed(2) }}</span>
									</td>
								</tr>
								<tr>
									<td :colspan="tableTitles.length + 1" style="text-align: right;">
										<div>{{ taxFlag == 0 ? '不含税' : '含税' }}价格：
											<span v-if="taxFlag == 0 || taxFlag == 2">{{ totalPrice.toFixed(2) }}</span>
											<span v-if="taxFlag == 1">{{ (totalPrice / 0.9).toFixed(2) }}</span>
										</div>
									</td>
								</tr>
								<tr>
									<td :colspan="tableTitles.length + 1" class="table_bg">
										<div class="total_price">
											<span>合计人民币（大写）：</span>
											<span class="f_bold">{{ upperCaseTotalPrice }}</span>
										</div>
									</td>
								</tr>
							</table>
						</div>

						<div class="agree_info">
							<!-- <div style="font-size: 14px;text-align: center;font-weight: bold;" class="bt"></div> -->
							<div v-html="protocolContent" class="rich-txt"></div>
						</div>
					</div>
					<!-- 备注 -->
					<!-- <div class="beizhu">
						<div class="bt">
							<span class="lf">备注</span>
						</div>
						<div class="cot">{{ forwardDesc }}</div>
					</div> -->
					<div class="sign_box">
						<div class="sign_item">
							<div class="bt">卖方签字</div>
							<div class="sign_content">
								<img :src="sysQuotationSheet.saleSignImg" class="img"
									v-if="sysQuotationSheet && sysQuotationSheet.saleSignImg" />
							</div>
							<div class="sign_tip" v-if="sysQuotationSheet && !sysQuotationSheet.saleSignImg">待签字</div>
							<div class="signed" v-if="sysQuotationSheet && sysQuotationSheet.saleSignImg">{{
								sysQuotationSheet.saleSignTime }}
								签署</div>
							<template v-if="sysQuotationSheet && sysQuotationSheet.departSignImg">
								<img :src="sysQuotationSheet.departSignImg" class="zhang" />
							</template>
						</div>
						<div class="sign_item" @click="sign()">
							<div class="bt">买方签字</div>
							<div class="sign_content">
								<img :src="sysQuotationSheet.buySignImg" class="img"
									v-if="sysQuotationSheet && sysQuotationSheet.buySignImg" />
							</div>
							<div class="sign_tip" v-if="sysQuotationSheet && !sysQuotationSheet.buySignImg">待签字<br />请在确认卖方签字后再签</div>
							<div class="signed" v-if="sysQuotationSheet && sysQuotationSheet.buySignImg">{{
								sysQuotationSheet.buySignTime }}
								签署</div>
							<template v-if="sysQuotationSheet && sysQuotationSheet.buyDepartSignImg">
								<img :src="sysQuotationSheet.buyDepartSignImg" class="zhang" />
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>
		<PriceOrderAutograph @signAutoGraph="signAutoGraph" ref="autoGraph" :hasPass="false" :hasTips="true">
		</PriceOrderAutograph>
	</div>
</template>

<script>
import axios from "axios"
import {
	// getParam,
	getQueryString,
	convertCurrency,
	base64toFile,
	timeStampToYMDsfm,
	isInWechatMiniProgram
	// dataURLtoBlob
} from "@/common/comm.js"
import $http from "@/common/api/request.js"
import PriceOrderAutograph from '@/components/PriceOrderAutograph.vue'
import { EasyScroller } from 'easyscroller'
export default {
	name: "contract",
	data() {
		return {
			isInit: true,
			priceFields: '',
			from: "",
			statusBarHeight: 0,
			navigatorBarHeight: 0,
			topH: 0,
			status: null,
			navigatorTitle: "",
			isShowMenu: false,
			sellerIsSign: false, // 卖方是否签字
			salt: "",
			ordId: "",
			contId: "",
			userId: "",
			taxFlag: '0',
			contractTypeStr: '',
			taxPrice: 0,
			forwardId: null,
			contractStatus: "",
			contractDetail: null,
			customerInfo: null,
			orderAddressInfo: null,
			ord: null, // 订单Id
			userInfo: null,
			productList: [],
			totalCount: 0,
			totalPrice: 0,
			upperCaseTotalPrice: "",
			protocolContent: "",
			isShowProtocolDialog: false,
			sysQuotationSheet: null,
			buyDepartSignImg: '',
			buySignImg: '',
			forwardDesc: '',
			scroller: null, //'outFactoryPrice'
			printFields: ['productName', 'standardsName', 'unitName', 'orderNum', 'ps', 'areaNumContract', 'totalAreaNumContract', 'areaUnitPrice', 'outFactoryBasePrice', 'totalAmountContract'],
			tableTitles: [],
			selectTableTitles: [{
				value: 'productName',
				text: '产品名称',
				checked: true
			}, {
				value: 'standardsName',
				text: '规格型号',
				checked: true
			},
			{
				value: 'unitName',
				text: '单位',
				checked: true
			}, {
				value: 'orderNum',
				text: '数量',
				checked: true
			},
			{
				value: 'ps',
				text: '参数',
				checked: true
			}, {
				value: 'areaNumContract',
				text: '面积',
				checked: true
			},
			{
				value: 'totalAreaNumContract',
				text: '合计面积',
				checked: true
			},
			{
				value: 'areaUnitPrice',
				text: '平方单价',
				checked: true
			},
			{
				value: 'outFactoryBasePrice',
				text: '单件价',
				checked: true
			}, {
				value: 'totalAmountContract',
				text: '小计',
				checked: true
			},
			],
			originTableTitles: [{
				key: 'productName',
				label: '产品名称',
				width: '16vw'
			},
			{
				key: 'standardsName',
				label: '规格型号',
				width: '20vw'
			},
			{
				key: 'unitName',
				label: '单位',
				width: '6vw'
			},
			{
				key: 'orderNum',
				label: '数量',
				width: '6vw'
			},
			{
				key: 'ps',
				label: '参数',
				width: '18vw'
			},
			{
				key: 'areaNumContract',
				label: '面积',
				width: '6vw'
			},
			{
				key: 'totalAreaNumContract',
				label: '合计面积',
				width: '6vw'
			},
			{
				key: 'areaUnitPrice',
				label: '平方单价',
				width: '6vw'
			},
			{
				key: 'outFactoryBasePrice',
				label: '单件价￥',
				width: '6vw'
			},
			{
				key: 'totalAmountContract',
				label: '小计',
				width: '6vw',
				fontWeight: '700'
			}
			],
			configCode: "",
			originContractVersionId: null,
			contractVersionId: null,
			isShowOrderNum: true,
			isShowOutFactoryPrice: true,
			isShowUnitPrice: true,
			isShowTotalAmount: true,
		}
	},
	components: {
		PriceOrderAutograph
	},
	mounted() {
		let request = getQueryString()
		this.ordId = request['id']
		this.salt = request['salt']
		this.ord = request['orderId']
		this.contId = request['contId']
		this.userId = request['userId']
		this.taxFlag = request['taxFlag']
		this.getContractDetail()
	},
	beforeDestroy() {
		if (this.scroller) this.scroller.destroy()
	},
	methods: {
		getContractDetail() {
			let params = {
				url: `/sys/order/preview?id=${this.ordId}&salt=${this.salt}&contId=${this.contId}&userId=${this.userId}`,
				method: 'GET',
				header: {
					'Content-Type': 'application/json'
				}
			}
			$http.request(params).then((res) => {
				if (res.code == 200) {
					this.contractDetail = res.result
					this.contractVersionId = res.result.contractVersionId
					this.priceFields = res.result.priceFields
					this.customerInfo = res.result.customerInfoVO
					this.userInfo = res.result.userInfoVO
					this.orderAddressInfo = res.result.orderAddressVO
					this.contractVersionId = res.result.contractVersionId
					if (res.result.sysQuotationSheet) {
						let sysQuotationSheet = res.result.sysQuotationSheet
						this.sysQuotationSheet = {
							...sysQuotationSheet,
							saleSignTime: sysQuotationSheet.saleSignTime ? timeStampToYMDsfm(sysQuotationSheet.saleSignTime) : '',
							buySignTime: sysQuotationSheet.buySignTime ? timeStampToYMDsfm(sysQuotationSheet.buySignTime) : ''
						}
					}
					this.productList = this.handerProduct(res.result.orderProductVOList)
					this.contractStatus = res.result.contractStatus
					this.handlerProtocal(res.result.protocolList);
					this.forwardDesc = res.result.forwardDesc || ''
					this.calcCountAndPrice()
					if(this.taxFlag == 0 || this.taxFlag == 2) {
						this.upperCaseTotalPrice = convertCurrency(this.totalPrice.toFixed(2))
					}
					if (this.taxFlag == 1) {
						this.upperCaseTotalPrice = convertCurrency((this.totalPrice / 0.9).toFixed(2))
					}
					this.navigatorTitle = '合同 ' + res.result.contractNo.replace(/^#?ht/i, 'HT').replace(/(\d{8})\d{6}/, '$1')
					if (!isInWechatMiniProgram()) {
						document.title = this.navigatorTitle
					}
					this.setPriceFields()
					if (this.contractVersionId == -1 || !this.contractVersionId) {
						if (res.result.protocolList && res.result.protocolList.length > 0) {
							this.contractTypeStr = res.result.protocolList[0].configName
						}
					} else {
						if (res.result.protocolList && res.result.protocolList.length > 0) {
							this.contractTypeStr = res.result.protocolList.find(s => s.id == this.contractVersionId).configName
						}
					}
				}
				this.isInit = true
			}).catch(() => { })
		},
		handlerProtocal(protocolList = []) {
			if (!this.contractVersionId || this.contractVersionId == -1) {
				this.originContractVersionId = protocolList.length > 0 ? protocolList[0].id : ''
				this.contractVersionId = protocolList.length > 0 ? protocolList[0].id : ''
				this.protocolContent = protocolList.length > 0 ? protocolList[0].content : ''
				this.configCode = protocolList.length > 0 ? protocolList[0].configCode : ''
			} else {
				this.originContractVersionId = this.contractVersionId
				let tempA = protocolList.filter(e => {
					return e.id == this.contractVersionId
				})
				if (tempA && tempA.length > 0) {
					this.protocolContent = tempA[0].content
					this.configCode = tempA[0].configCode
				}
			}
		},
		handerProduct(orderProductVOList) {
			let tempArr = []
			orderProductVOList = orderProductVOList.filter((pro) => pro.isAttachProd == 0)
			orderProductVOList.forEach((product) => {
				return product.orderItemVOList.forEach((orderItem) => {
					let ps = []
					// 处理参数A
					let alist = product.aPriceRateVOList;
					if (alist?.length) {
						let obj = JSON.parse(product.aPriceRateLable);
						let tit = Object.values(obj);
						let vStr = orderItem.thicknessIdPathA;
						let vArr = vStr ? vStr.split("-") : [];
						if (vArr.length) {
							let aVal = [];
							let ii = alist.findIndex((x) => x.id == vArr[0]);
							if (ii > -1) {
								aVal.push(alist[ii].texture);
								let jj = alist[ii].thicknessVOList.findIndex(
									(x) => x.id == vArr[1]
								);
								let v =
									jj > -1 ?
										alist[ii].thicknessVOList[jj].thickness :
										"--";
								aVal.push(v);
							} else {
								aVal = ["--", "--"];
							}
							for (let n = 0; n < tit.length; n++) {
								ps.push(aVal[n]);
							}
						}
					}
					// 处理参数B
					let blist = product.bPriceRateVOList;
					if (blist?.length) {
						let obj = JSON.parse(product.bPriceRateLable);
						let tit = Object.values(obj);
						let vStr = orderItem.thicknessIdPathB;
						let vArr = vStr ? vStr.split("-") : [];
						if (vArr.length) {
							let aVal = [];
							let ii = blist.findIndex((x) => x.id == vArr[0]);
							if (ii > -1) {
								aVal.push(blist[ii].texture);
								let jj = blist[ii].thicknessVOList.findIndex(
									(x) => x.id == vArr[1]
								);
								let v =
									jj > -1 ?
										blist[ii].thicknessVOList[jj].thickness :
										"--";
								aVal.push(v);
							} else {
								aVal = ["--", "--"];
							}
							for (let n = 0; n < tit.length; n++) {
								ps.push(aVal[n]);
							}
						}
					}
					// 处理参数M
					let clist = product.materialVOList;
					if (clist?.length) {
						let obj = JSON.parse(product.materialLable);
						let tit = Object.values(obj);
						let vStr = orderItem.materialLastId;
						if (vStr) {
							let aVal = [];
							let ii = clist.findIndex((x) => x.id == vStr);
							if (ii > -1) {
								aVal.push(clist[ii].name);
							} else {
								aVal = ["--"];
							}
							for (let n = 0; n < tit.length; n++) {
								ps.push(aVal[n]);
							}
						}
					}
					if (product.proType == 3) {
						// 自定义商品
						ps = orderItem.isPower ? [orderItem.isPower] : []
					}
					if (product.proType == 1) {
						// 成品件
						let powerStr = "",
							voltageStr = ""
						let powerLable = product.powerLable
						let voltageLable = product.voltageLable
						let productItemObj = product.productItemVOList.find(sub => sub.id == orderItem
							.productItemId)
						if (productItemObj) {
							powerStr = product.powerShow == 1 ? powerLable + ":" + productItemObj.powerSize :
								""
							voltageStr = product.voltageShow == 1 ? voltageLable + ":" + productItemObj
								.voltage : ""
						}
						ps = [powerStr, voltageStr]
					}
					tempArr.push({
						...orderItem,
						unitName: product.unitName,
						productName: product.productName,
						proType: product.proType,
						ps: ps.join('|')
					})
				})
			})
			return tempArr
		},
		setPriceFields() {
			let printFields = []
			if (this.priceFields && this.priceFields.includes(',')) {
				printFields = this.priceFields.split(",")
			}
			if (this.priceFields && !this.priceFields.includes(',')) {
				printFields = [this.priceFields]
			}
			if (printFields && printFields.length == 1 && printFields[0] == 'no') {
				printFields = []
			}
			if (!this.priceFields) {
				printFields = ['productName', 'standardsName', 'unitName', 'orderNum', 'ps', 'areaNumContract', 'totalAreaNumContract', 'areaUnitPrice', 'outFactoryBasePrice', 'totalAmountContract']
			}
			this.printFields = printFields.filter(item => item != 'outFactoryPrice')
			this.changePrintFileds()
		},
		changePrintFileds() {
			this.selectTableTitles.forEach(m => m.checked = false)
			this.selectTableTitles.forEach(m => {
				if (this.printFields.indexOf(m.value) >= 0) {
					m.checked = true
				}
			})
			let orderNumIndex = this.printFields.findIndex(item => item == 'orderNum')
			if (orderNumIndex < 0) {
				this.isShowOrderNum = false
			} else {
				this.isShowOrderNum = true
			}
			let outFactoryPriceIndex = this.printFields.findIndex(item => item == 'outFactoryPrice')
			if (outFactoryPriceIndex < 0) {
				this.isShowOutFactoryPrice = false
			} else {
				this.isShowOutFactoryPrice = true
			}
			let unitPriceindex = this.printFields.findIndex(item => item == 'outFactoryBasePrice')
			if (unitPriceindex < 0) {
				this.isShowUnitPrice = false
			} else {
				this.isShowUnitPrice = true
			}
			let totalAmountIndex = this.printFields.findIndex(item => item == 'totalAmountContract')
			if (totalAmountIndex < 0) {
				this.isShowTotalAmount = false
			} else {
				this.isShowTotalAmount = true
			}
			this.tableTitles = this.originTableTitles.filter(item => {
				return this.printFields.indexOf(item.key) >= 0
			})
		},
		handerNodeValueList(nodeValueList) {
			let nodeStr = ""
			nodeValueList.forEach((item, index) => {
				if (index == nodeValueList.length - 1) {
					nodeStr += item.nodeValue
				} else {
					nodeStr += item.nodeValue + '*'
				}
			})
			return nodeStr
		},
		setScroller() {
			const ele = document.querySelector('#zoomBox'); //缩放盒子
			this.scroller = new EasyScroller(ele, {
				scrollingX: true,
				scrollingY: true,
				zooming: true,
				minZoom: 1,    //最小缩放
				maxZoom: 4,    //最大缩放
				zoomLevel: 1, //初始值缩放
				bouncing: false
			});
		},
		calcCountAndPrice() {
			this.totalCount = 0
			this.totalPrice = 0
			this.productList.forEach((item) => {
				this.totalCount += item.orderNum
				this.totalPrice += item.totalAmountContract
			})
		},
		sign() {
			if (this.sysQuotationSheet && this.sysQuotationSheet.buySignImg) {
				return
			}
			this.$refs.autoGraph.show()
		},
		async signAutoGraph({ signPath, departName }) {
			let sealData = null;
			if (departName != '') {
				sealData = await this.getDepartSeal(departName)
			}
			const signData = await this.uploadSignImg(signPath)
			if (sealData) {
				Promise.all([sealData, signData]).then(results => {
					this.buyDepartSignImg = results[0] // 买方公司印章图片
					this.buySignImg = results[1] // 买方签名图片
					this.updateSignInfo()
				})
			} else {
				Promise.all([signData]).then(results => {
					this.buySignImg = results[0]
					this.updateSignInfo()
				})
			}
		},
		getDepartSeal(departName) {
			return new Promise((resolve, reject) => {
				let params = {
					url: '/sys/user/departSeal?departName=' + departName,
					header: {
						'Content-Type': 'application/json',
						'X-Access-Token': this.token
					},
				}
				$http.request(params).then((res) => {
					if (res.code == 200) {
						resolve(res.result)
					} else {
						reject('error')
					}
				}).catch((error) => {
					console.log(error)
				})
			})
		},
		uploadSignImg(signPath) {
			return new Promise((resolve, reject) => {
				let file = base64toFile(signPath, new Date().getTime() + Math.random() + ".jpg")
				const formData = new FormData();
				formData.append("file", file)
				axios({
					method: "post",
					headers: {
						"Content-Type": "multipart/form-data",
					},
					url: "https://fengyisuan.com/app/sys/common/upload",
					data: formData,
				})
					.then(function (res) {
						if (res.data.code == 200) {
							resolve(res.data.result)
						} else {
							reject('error')
						}
					})
					.catch(function (error) {
						console.log(error)
					});
			})
		},
		// 更新签名信息
		updateSignInfo() {
			let params = {
				url: '/sys/order/updateSignInfo',
				method: 'POST',
				header: {
					'Content-Type': 'application/json'
				},
				data: {
					orderId: this.ord,
					contractId: this.contractDetail.id,
					buyDepartSignImg: this.buyDepartSignImg, // 买方公司印章图
					buySignImg: this.buySignImg, // 买方签名图片
					signType: 2
				}
			}
			$http.request(params).then((res) => {
				if (res.code == 200) {
					this.getContractDetail()
				}
			}).catch((err) => {
				console.log(err)
			})
		},
		showMenus() {
			this.isShowMenu = true
		},
		hideMenus() {
			this.isShowMenu = false
		},
		deleteContract() {
			this.hideMenus()
			this.$refs.popup.show()
		},
		conformDelContract() {
			let params = {
				url: '/sys/order/removeContract?contId=' + this.contId,
				method: 'POST',
				header: {
					'Content-Type': 'application/json',
					'X-Access-Token': this.token
				}
			}
			$http.request(params).then((res) => {
				if (res.code == 200) {
					// this.goBack()
				}
				this.hidePopup()
			}).catch(() => { })
		},
		hideEditor() {
			this.isShowProtocolDialog = false
		},
		hidePopup() {
			this.$refs.popup.hide()
		}
	}
}
</script>
<style>
body {
	background-color: #f5f5f5;
	padding: 0 !important;
	margin: 0 !important;
	overflow: visible;
}
</style>
<style>
@media print {

	html,
	body {
		height: auto !important;
		overflow: visible !important;
		margin: 0 !important;
		padding: 0 !important;
		background: white;
	}

	.container {
		height: auto !important;
		overflow: visible !important;
	}

	.contract_title {
		font-size: 10pt !important;
		text-align: center;
		display: block !important;
		position: relative !important;
	}

	.contractno {
		position: absolute !important;
		right: 10px !important;
		top: 10px !important;
	}

	.mytable td {
		font-size: 9pt !important;
	}

	.project_info .title {
		font-size: 10pt !important;
	}

	.project_main {
		font-size: 9pt !important;
	}

	.mytable1 td {
		font-size: 9pt !important;
	}

	.agree_info .bt,
	.beizhu .bt {
		font-size: 10pt !important;
		font-weight: bold !important;
	}

	.beizhu {
		border-top: 0 !important;
	}

	.sign_box {
		margin-top: 0 !important;
	}

	tfoot {
		display: table-row-group;
		/* 或者 display: block; */
	}

	.sign_content {
		border: 1px solid #000 !important;
	}

	/* 强制签名区域不被分页打断 */
	.sign_box,
	.sign-item,
	.sign-item .write,
	.sign-item .zhang {
		page-break-inside: avoid !important;
		break-inside: avoid !important;
		/* 新版 CSS 属性，兼容性更好 */
	}


}

.contract_container {
	/* padding-top: 44px; */
	padding: 0;
}

.no-pad {
	padding-bottom: 0 !important;
}

.container {
	/* height: 100vh;
	overflow: hidden; */
}

.product_info {
	overflow-x: auto;
}

.top {
	/* position: fixed;
	left: 0;
	right: 0;
	top: 0;
	z-index: 10; */
	background-color: #fff;
	width: 100%;
	height: 44px;
	text-align: center;
	font-size: 18px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.status-bar {
	width: 100%;
}

.navgator-bar {
	width: 100%;
	padding: 0 18rpx;
	box-sizing: border-box;
	/* background-color: #0072DC; */
	color: #242424;
	display: flex;
	justify-content: space-between;
	align-items: center;
	position: relative;
}

.menus {
	width: 222rpx;
	position: absolute;
	right: 20rpx;
	top: 0;
	z-index: 20;
}

.menus .m_unit {
	width: 222rpx;
	height: 98rpx;
	font-size: 30rpx;
	color: #000;
	background-color: #fff;
	text-align: center;
	line-height: 98rpx;
	margin-bottom: 10rpx;
}

.menus .m_unit:last-child {
	margin-bottom: 0;
}

.mask {
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background: rgba(0, 0, 0, .5);
}

.contract_main {
	display: flex;
	flex-direction: column;
	background-color: #fff;
	margin-top: 10px;
}

.tips {
	text-align: center;
	font-size: 11px;
	color: #ff0000;
	padding: 15px 0 15px 0;
	border-bottom: 1px solid #000;
}

.contract_title {
	font-size: 12px;
	font-weight: bold;
	text-align: center;
	padding: 8px;
	display: flex;
	justify-content: space-between;
	/* border-left: 1px solid #000;
	border-right: 1px solid #000; */
}

.contract_title .contractno {
	font-weight: normal;
	font-size: 10px;
}

.mytable {
	width: 100%;
	border: 1px solid #000;
	border-left: 0;
	border-right: 0;
	box-sizing: border-box;
}

.mytable td {
	font-size: 12px;
	border-right: 1px solid #9F9F9F;
	padding: 5px;
	vertical-align: top;
}

.top_line {
	border-top: 1px solid #000;
	border-right: 0 !important;
}

.mytable .b_in {
	display: flex;
	justify-content: space-between;
}

.mytable .noborder {
	border-right: 0;
}

.project_info {
	/* border-left: 1px solid #000;
	border-right: 1px solid #000; */
	border-bottom: 1px solid #000;
	display: flex;
	flex-direction: column;
	padding: 7px 8px;
}

.project_info .title {
	font-size: 12px;
	font-weight: bold;
	margin-bottom: 9px;
}

.project_main {
	display: flex;
	justify-content: space-between;
	font-size: 12px;
}

.mytable1 {
	width: 100%;
	border: 1px solid #000;
	border-right: 0;
	border-top: 0;
	border-bottom: 0;
	/* border-bottom: 1px solid #9F9F9F; */
}

.mytable1 td {
	font-size: 12px;
	border-bottom: 1px solid #000;
	border-right: 1px solid #000;
	padding: 5px;
	vertical-align: top;
	text-align: center;
	white-space: nowrap;
}

.table_bg {
	background-color: #F6F6F6;
}

.f_bold {
	font-weight: bold;
}

.total_price {
	display: flex;
	justify-content: space-between;
	padding: 0;
}

.agree_info {
	font-size: 12px;
	padding: 10px 10px;
	line-height: 20px;
}

.agree_info p {
	padding: 0 !important;
	margin: 0 !important;
}

.rich-txt {
	word-break: break-all;
	/* white-space: pre-line; */
}

.sign_box {
	background-color: #fff;
	margin-top: 10px;
	padding: 20px 10px 20px 10px;
	display: flex;
	justify-content: space-between;
}

.sign_item {
	width: 172px;
	font-size: 13px;
	display: flex;
	flex-direction: column;
	position: relative;
}

.sign_item .zhang {
	width: 109px;
	height: 109px;
	position: absolute;
	right: 10px;
	bottom: 0;
}

.sign_item .bt {
	text-align: center;
	margin-bottom: 12px;
}

.sign_item .sign_tip {
	text-align: center;
	color: #FF0000;
	margin-top: 14px;
}

.sign_item .signed {
	text-align: center;
	color: #000;
	margin-top: 14px;
}

.sign_content {
	width: 172px;
	height: 110px;
	background: #F5F5F5;
	border: 1px solid #A3A3A3;
	display: flex;
	align-items: center;
	justify-content: center;
}

.sign_content .img {
	width: 88px;
	height: 67px;
}

.foot {
	width: 100%;
	height: 49px;
	background-color: #fff;
	position: fixed;
	display: flex;
	left: 0;
	bottom: 0;
}

.foot .f_u {
	flex: 1;
	height: 49px;
	text-align: center;
	line-height: 49px;
	font-size: 15px;
}

.foot .f_u.grey {
	background-color: #848484;
	color: #fff;
}

.foot .f_u.transfer {
	background-color: #2BA246;
	color: #fff;
}

.txtinfo {
	font-size: 15px;
}

.ft {
	width: 100%;
	display: flex;
}

.table_foot td {
	background-color: #F6F6F6;
	padding: 10px 0;
}

.table_foot .txt {
	font-weight: bolder;
}

.ft_u {
	flex: 1;
	height: 39px;
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 15px;
	border-right: 1px solid #EBEBEB;
}

.ft_u:last-child {
	border-right: 0;
}

.placeorder {
	background-color: #F83144;
	color: #fff;
}

.ft_u.cancel {
	color: #F83345;
}

.mark {
	position: fixed;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, .5);
	z-index: 100;
}

.beizhu {
	font-size: 10px;
	padding: 10px 10px 24px 10px;
	background-color: #fff;
	border-top: 10px solid #F6F6F6;
	overflow: hidden;
}

.beizhu .bt {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.beizhu .cot {
	padding: 10px 0;
}
</style>